(function () {
  console.log("[VIF] Script chargé");

  let filterTimer = null;
  let observerStarted = false;
  let lastPopupOpen = false;

  function injectStyles() {
    let style = document.getElementById("vif-styles");

    if (!style) {
      style = document.createElement("style");
      style.id = "vif-styles";
      document.head.appendChild(style);
    }

    /*
      Le masquage ne dépend que de la classe : aucun recalcul de contexte
      ne peut faire réapparaître les images.
    */
    style.textContent = `
      .vif-media-hidden {
        display: none !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
    `;
  }

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  }

  function mapLogoValue(value) {
    const normalized = normalize(value);

    const logoMap = {
      "coeur-v1": "logo1",
      "coeur-v2": "logo2"
    };

    return logoMap[normalized] || normalized;
  }

  function isInsideCart(node) {
    if (!node || node.nodeType !== 1) return false;

    return Boolean(
      node.closest &&
      node.closest(
        "cart-drawer, cart-notification, .cart-drawer, #CartDrawer, .cart-notification, .cart-drawer__form, .cart-items, .cart, #cart-notification, .drawer"
      )
    );
  }

  function isInsidePopup(node) {
    /*
      Un élément situé dans une popup (quick-add, quick-view, modal)
      appartient à un contexte produit légitime : il doit être filtrable
      même si la popup est imbriquée dans une carte produit dans le DOM
      (cas de Dawn : quick-add-modal est DANS la carte).
    */
    if (!node || node.nodeType !== 1 || !node.closest) return false;

    return Boolean(
      node.closest(
        "dialog, quick-add-modal, .quick-add-modal, .modal, .popup, .quick-view, .quick-view-modal"
      )
    );
  }

  function isInsideProductCard(node) {
    /*
      GARDE-FOU : une image de carte produit (grille collection, produits
      recommandés, accueil) ne doit JAMAIS être filtrée.
      EXCEPTION : si l'élément est dans une popup, il est légitime,
      même si la popup est imbriquée dans la carte dans le DOM.
    */
    if (!node || node.nodeType !== 1 || !node.closest) return false;

    if (isInsidePopup(node)) return false;

    if (node.closest("product-card, .card-wrapper, .product-card, .card--product")) {
      return true;
    }

    if (node.closest("a[href*='/products/'], a[href*='/produits/']")) {
      return true;
    }

    return false;
  }

  function getCartRoots() {
    return Array.from(
      document.querySelectorAll(
        "cart-drawer, #CartDrawer, .cart-drawer, cart-notification, #cart-notification, .cart-notification"
      )
    );
  }

  function isCartOpen() {
    return getCartRoots().some(function (cartRoot) {
      if (cartRoot.hasAttribute("open")) return true;
      if (cartRoot.classList.contains("active")) return true;
      if (cartRoot.classList.contains("animate")) return true;
      if (cartRoot.classList.contains("is-open")) return true;
      if (cartRoot.classList.contains("drawer--open")) return true;

      if (cartRoot.getAttribute("aria-hidden") === "true") return false;
      if (cartRoot.hasAttribute("hidden")) return false;

      const style = window.getComputedStyle(cartRoot);

      if (style.display === "none") return false;
      if (style.visibility === "hidden") return false;

      const rect = cartRoot.getBoundingClientRect();

      return (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.right > 0 &&
        rect.left < window.innerWidth
      );
    });
  }

  function isVisibleElement(el) {
    if (!el || el === document || el === document.body) return true;
    if (el.hasAttribute("hidden")) return false;
    if (el.getAttribute("aria-hidden") === "true") return false;

    const style = window.getComputedStyle(el);

    if (style.display === "none") return false;
    if (style.visibility === "hidden") return false;
    if (style.opacity === "0") return false;

    const rect = el.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0;
  }

  function hasFilterImages(root) {
    if (!root || !root.querySelector) return false;

    return Boolean(
      root.querySelector("img[alt^='filter-'], img[alt='always']")
    );
  }

  function cleanupAllVifClasses() {
    if (isCartOpen()) return;

    document
      .querySelectorAll(".vif-hidden, .vif-media-hidden, [data-vif-managed='true']")
      .forEach(function (el) {
        if (!isInsideCart(el)) {
          el.classList.remove("vif-hidden");
          el.classList.remove("vif-media-hidden");
          el.removeAttribute("data-vif-managed");
        }
      });
  }

  function cleanupProductCards() {
    /*
      Filet de sécurité : retire toute classe de filtrage posée sur une
      carte produit ou dedans (hors popup).
    */
    document
      .querySelectorAll(".vif-hidden, .vif-media-hidden, [data-vif-managed='true']")
      .forEach(function (el) {
        if (isInsideProductCard(el) || isProductCardContainer(el)) {
          el.classList.remove("vif-hidden");
          el.classList.remove("vif-media-hidden");
          el.removeAttribute("data-vif-managed");
        }
      });
  }

  function getVisiblePopupRoot() {
    const selectors = [
      "dialog",
      "quick-add-modal",
      ".quick-add-modal",
      ".modal",
      ".popup",
      ".quick-view",
      ".quick-view-modal"
    ];

    for (const selector of selectors) {
      const elements = Array.from(document.querySelectorAll(selector));

      for (const el of elements) {
        if (isInsideCart(el)) continue;
        if (!isVisibleElement(el)) continue;
        if (!hasFilterImages(el)) continue;

        if (el.matches("dialog") && !el.hasAttribute("open")) continue;

        return el;
      }
    }

    return null;
  }

  function isProductUrl() {
    return (
      window.location.pathname.includes("/products/") ||
      window.location.pathname.includes("/produits/")
    );
  }

  function hasMainProductContainer() {
    return Boolean(
      document.querySelector("product-info") ||
      document.querySelector("main-product") ||
      document.querySelector("[data-section-type='main-product']") ||
      document.querySelector(".product__info-container")
    );
  }

  function isRealProductPage() {
    return Boolean(
      isProductUrl() ||
      hasMainProductContainer()
    );
  }

  function isCollectionPage() {
    if (isRealProductPage()) return false;

    return Boolean(
      document.querySelector(".collection") ||
      document.querySelector("product-card") ||
      document.querySelector(".card-wrapper") ||
      document.querySelector(".product-grid") ||
      window.location.pathname.includes("/collections/")
    );
  }

  function getProductPageRoot() {
    const candidates = [
      document.querySelector("product-info"),
      document.querySelector("main-product"),
      document.querySelector("[data-section-type='main-product']"),
      document.querySelector(".product"),
      document.querySelector("main"),
      document.body
    ];

    for (const root of candidates) {
      if (!root) continue;
      if (isInsideCart(root)) continue;
      if (!hasFilterImages(root)) continue;

      return root;
    }

    if (isRealProductPage()) {
      return document.body;
    }

    return null;
  }

  function getActiveMediaRoot() {
    const popupRoot = getVisiblePopupRoot();

    if (popupRoot) {
      lastPopupOpen = true;
      return popupRoot;
    }

    if (isCollectionPage()) {
      cleanupAllVifClasses();
      lastPopupOpen = false;
      return null;
    }

    if (lastPopupOpen && !isRealProductPage()) {
      cleanupAllVifClasses();
      lastPopupOpen = false;
      return null;
    }

    if (isRealProductPage()) {
      return getProductPageRoot();
    }

    return null;
  }

  function getOptionRoot(mediaRoot) {
    const popupRoot = getVisiblePopupRoot();

    if (popupRoot) return popupRoot;
    if (mediaRoot) return mediaRoot;

    return document.body;
  }

  function getSelectedOptionByName(root, possibleNames) {
    if (!root) return null;

    const normalizedNames = possibleNames.map(normalize);

    const searchRoots = [];

    searchRoots.push(root);

    const popupRoot = getVisiblePopupRoot();
    if (popupRoot && !searchRoots.includes(popupRoot)) {
      searchRoots.push(popupRoot);
    }

    if (isRealProductPage()) {
      const productInfo = document.querySelector("product-info");
      if (productInfo && !searchRoots.includes(productInfo)) {
        searchRoots.push(productInfo);
      }

      const productRoot = document.querySelector(".product");
      if (productRoot && !searchRoots.includes(productRoot)) {
        searchRoots.push(productRoot);
      }

      searchRoots.push(document.body);
    }

    for (const searchRoot of searchRoots) {
      const containers = searchRoot.querySelectorAll(
        "variant-radios fieldset, variant-selects .product-form__input, .product-form__input, fieldset"
      );

      for (const container of containers) {
        if (isInsideCart(container)) continue;

        const label = container.querySelector("legend, label, .form__label");
        const labelText = normalize(label ? label.textContent : "");

        const isTargetOption = normalizedNames.some(function (name) {
          return labelText.includes(name);
        });

        if (!isTargetOption) continue;

        const checkedRadio = container.querySelector("input[type='radio']:checked");
        if (checkedRadio) return checkedRadio.value;

        const select = container.querySelector("select");
        if (select) return select.value;

        const selectedButton = container.querySelector(
          "[aria-selected='true'], [aria-pressed='true']"
        );
        if (selectedButton) return selectedButton.textContent.trim();
      }
    }

    return null;
  }

  function getAllowedKeys(optionRoot) {
    const frontLogo = getSelectedOptionByName(optionRoot, [
      "Logo avant",
      "Logo",
      "Avant"
    ]);

    const color = getSelectedOptionByName(optionRoot, [
      "Couleur",
      "Color",
      "Colour"
    ]);

    if (!frontLogo || !color) {
      console.warn("[VIF] Logo ou couleur introuvable", {
        frontLogo: frontLogo,
        color: color
      });

      return [];
    }

    const keys = [
      "filter-" + mapLogoValue(frontLogo) + "-" + normalize(color),
      "filter-color-" + normalize(color),
      "always"
    ];

    console.log("[VIF] Clés autorisées :", keys);

    return keys;
  }

  function getFilterableImages(root) {
    if (!root || !root.querySelectorAll) return [];

    function isFilterable(img) {
      if (isInsideCart(img)) return false;
      if (isInsideProductCard(img)) return false;

      const alt = normalize(img.getAttribute("alt") || "");

      return alt.startsWith("filter-") || alt === "always";
    }

    let images = Array.from(root.querySelectorAll("img")).filter(isFilterable);

    if (!images.length && isRealProductPage()) {
      images = Array.from(document.querySelectorAll("img")).filter(isFilterable);
    }

    const popupRoot = getVisiblePopupRoot();

    if (popupRoot) {
      const popupImages = Array.from(popupRoot.querySelectorAll("img")).filter(
        isFilterable
      );

      if (popupImages.length) {
        images = popupImages;
      }
    }

    console.log("[VIF] Images filtrables :", images.length);

    return images;
  }

  function isProductCardContainer(target) {
    /*
      Ne jamais masquer un élément qui CONTIENT une carte produit —
      sauf s'il est lui-même dans une popup.
    */
    if (!target || !target.querySelector) return false;
    if (isInsidePopup(target)) return false;

    if (target.querySelector("product-card, .card-wrapper, .product-card, .card--product")) {
      return true;
    }

    if (
      target.matches &&
      target.matches("li") &&
      target.querySelector("a[href*='/products/'], a[href*='/produits/']")
    ) {
      return true;
    }

    return false;
  }

  function getTargets(img, mediaRoot) {
    const targets = [];

    const selectors = [
      ".product-media",
      ".dialog-thumbnails-list__thumbnail",
      ".product-media-container",
      ".product__media-item",
      ".product__media",
      ".product-gallery__media",
      "[data-media-id]",
      ".slider__slide",
      ".swiper-slide",
      ".splide__slide",
      ".flickity-cell",
      "li",
      "button"
    ];

    selectors.forEach(function (selector) {
      const target = img.closest(selector);

      if (!target) return;
      if (targets.includes(target)) return;
      if (isInsideCart(target)) return;
      if (isInsideProductCard(target)) return;
      if (isProductCardContainer(target)) return;

      if (mediaRoot && !mediaRoot.contains(target)) {
        return;
      }

      if (isCollectionPage()) {
        const popupRoot = getVisiblePopupRoot();

        if (!popupRoot || !popupRoot.contains(target)) {
          return;
        }
      }

      targets.push(target);
    });

    if (!targets.includes(img) && !isInsideCart(img) && !isInsideProductCard(img)) {
      if (mediaRoot && mediaRoot.contains(img)) {
        targets.push(img);
      }
    }

    return targets;
  }

  function resetFiltering(root) {
    if (!root || !root.querySelectorAll) return;

    root
      .querySelectorAll(".vif-hidden, .vif-media-hidden, [data-vif-managed='true']")
      .forEach(function (el) {
        if (!isInsideCart(el)) {
          el.classList.remove("vif-hidden");
          el.classList.remove("vif-media-hidden");
          el.removeAttribute("data-vif-managed");
        }
      });
  }

  function markHidden(target, shouldHide) {
    target.classList.toggle("vif-media-hidden", shouldHide);

    if (shouldHide) {
      target.setAttribute("data-vif-managed", "true");
    } else {
      target.removeAttribute("data-vif-managed");
    }
  }

  function cleanupCollectionPage() {
    if (isCartOpen()) return;
    if (!isCollectionPage()) return;

    const popupRoot = getVisiblePopupRoot();

    if (popupRoot) return;

    cleanupAllVifClasses();
  }

  function filterCurrentContext() {
    injectStyles();

    /*
      GEL TOTAL quand le panier est ouvert.
    */
    if (isCartOpen()) {
      console.log("[VIF] Panier ouvert, état figé");
      return;
    }

    const mediaRoot = getActiveMediaRoot();

    if (!mediaRoot) {
      cleanupCollectionPage();
      console.log("[VIF] Aucun contexte produit actif à filtrer");
      return;
    }

    const optionRoot = getOptionRoot(mediaRoot);
    const allowedKeys = getAllowedKeys(optionRoot);

    if (!allowedKeys.length) return;

    resetFiltering(mediaRoot);

    const images = getFilterableImages(mediaRoot);

    images.forEach(function (img) {
      const alt = normalize(img.getAttribute("alt") || "");
      const shouldShow = allowedKeys.includes(alt);

      console.log("[VIF]", alt, shouldShow ? "SHOW" : "HIDE");

      getTargets(img, mediaRoot).forEach(function (target) {
        markHidden(target, !shouldShow);
      });
    });

    cleanupProductCards();

    const firstVisibleImage = images.find(function (img) {
      return !img.classList.contains("vif-media-hidden");
    });

    if (firstVisibleImage) {
      const mediaGallery = mediaRoot.querySelector("media-gallery");

      if (mediaGallery && typeof mediaGallery.setActiveMedia === "function") {
        const mediaItem = firstVisibleImage.closest("[data-media-id]");
        const mediaId = mediaItem ? mediaItem.getAttribute("data-media-id") : null;

        if (mediaId) {
          mediaGallery.setActiveMedia(mediaId, false);
        }
      }
    }
  }

  function scheduleFilter() {
    if (filterTimer) {
      clearTimeout(filterTimer);
    }

    filterTimer = setTimeout(function () {
      filterCurrentContext();

      requestAnimationFrame(function () {
        filterCurrentContext();
      });

      setTimeout(filterCurrentContext, 150);
      setTimeout(filterCurrentContext, 350);
      setTimeout(filterCurrentContext, 700);
      setTimeout(filterCurrentContext, 1200);
    }, 120);
  }

  function startObserver() {
    if (observerStarted) return;

    observerStarted = true;

    const observer = new MutationObserver(function (mutations) {
      if (isCartOpen()) return;

      const relevantMutations = mutations.filter(function (mutation) {
        return (
          !isInsideCart(mutation.target) &&
          mutation.target !== document.body
        );
      });

      if (!relevantMutations.length) return;

      scheduleFilter();

      setTimeout(cleanupCollectionPage, 300);
      setTimeout(cleanupProductCards, 300);
      setTimeout(cleanupCollectionPage, 1500);
      setTimeout(cleanupProductCards, 1500);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["open", "hidden", "aria-hidden", "class", "style"]
    });
  }

  function init() {
    injectStyles();
    cleanupAllVifClasses();
    startObserver();
    scheduleFilter();

    document.addEventListener("change", function (event) {
      if (isInsideCart(event.target)) return;
      scheduleFilter();
    });

    document.addEventListener("input", function (event) {
      if (isInsideCart(event.target)) return;
      scheduleFilter();
    });

    document.addEventListener("click", function (event) {
      if (isInsideCart(event.target)) return;

      setTimeout(scheduleFilter, 50);

      setTimeout(cleanupCollectionPage, 300);
      setTimeout(cleanupProductCards, 300);
      setTimeout(cleanupCollectionPage, 1500);
      setTimeout(cleanupProductCards, 1500);
    });

    document.addEventListener("variant:change", scheduleFilter);
    document.addEventListener("variantChange", scheduleFilter);
    document.addEventListener("product:variant-change", scheduleFilter);
    document.addEventListener("shopify:section:load", scheduleFilter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();